"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const faFacebook_1 = require("@fortawesome/free-brands-svg-icons/faFacebook");
const faTwitter_1 = require("@fortawesome/free-brands-svg-icons/faTwitter");
const faInstagram_1 = require("@fortawesome/free-brands-svg-icons/faInstagram");
const faYoutube_1 = require("@fortawesome/free-brands-svg-icons/faYoutube");
const analyticsUtils_1 = require("../../../../utils/analyticsUtils");
const SocialLink_1 = __importDefault(require("../SocialLink"));
const styles = require('./SocialLinks.module.scss');
const socialLinksTrackingAttributes = {
    facebook: {
        category: analyticsUtils_1.AnalyticsCategoryType.Footer,
        action: 'click',
        label: 'facebook',
    },
    twitter: {
        category: analyticsUtils_1.AnalyticsCategoryType.Footer,
        action: 'click',
        label: 'twitter',
    },
    instagram: {
        category: analyticsUtils_1.AnalyticsCategoryType.Footer,
        action: 'click',
        label: 'instagram',
    },
    youtube: {
        category: analyticsUtils_1.AnalyticsCategoryType.Footer,
        action: 'click',
        label: 'youtube',
    },
};
const SocialLinks = () => (react_1.default.createElement("div", { className: styles.socialLinks },
    react_1.default.createElement(SocialLink_1.default, { className: (0, classnames_1.default)(styles.socialLink, styles.facebook), trackingAttributes: socialLinksTrackingAttributes.facebook, href: "https://www.facebook.com/pistonheads", icon: faFacebook_1.faFacebook }),
    react_1.default.createElement(SocialLink_1.default, { className: (0, classnames_1.default)(styles.socialLink, styles.twitter), trackingAttributes: socialLinksTrackingAttributes.twitter, href: "https://twitter.com/pistonheads", icon: faTwitter_1.faTwitter, iconTitle: "Follow us on Twitter" }),
    react_1.default.createElement(SocialLink_1.default, { className: (0, classnames_1.default)(styles.socialLink, styles.instagram), trackingAttributes: socialLinksTrackingAttributes.instagram, href: "https://www.instagram.com/pistonheads", icon: faInstagram_1.faInstagram, iconTitle: "Follow us on Instagram" }),
    react_1.default.createElement(SocialLink_1.default, { className: (0, classnames_1.default)(styles.socialLink, styles.youtube), trackingAttributes: socialLinksTrackingAttributes.youtube, href: "https://www.youtube.com/user/PistonHeadsTV", icon: faYoutube_1.faYoutube, iconTitle: "Follow us on YouTube" })));
exports.default = (0, react_1.memo)(SocialLinks);
//# sourceMappingURL=SocialLinks.js.map